import React, { useState, useEffect } from "react";
import { HeaderConfig } from "./config";
import { Box } from "@mui/material";
import CustomTable from "../../../core/custom-table";
import { HTTP_METHODS, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import FloatEngineDetails from "./float-engine-details";
import { convertToCamelCaseFromUnderScore, PAGE_LIMIT } from "../../../utils";
import moment from "moment";

const FloatEngines = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    results: [],
  });
  const [detail, setDetail] = useState({
    isOpen: false,
    data: {},
  });
  const [ticketDetails, setTicketDetails] = useState({});
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
  });
  const getPhysicalStatus = (engineNo) => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.ENGINE_PHYSICAL_STATUS}/${engineNo}`
    )
      .then((res) => {
        if (!res.message) {
          setTicketDetails((prevVal) => ({
            ...prevVal,
            enginePhysicalStatus: res?.batch || "",
          }));
        }
      })
      .catch((err) => console.error(err));
  };
  const loadData = (filters) => {
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.FLOAT_ENGINE}`,
      null,
      filters
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setData(res);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  const loadTickectData = (id) => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.STAGE_VIEW}/${id}`, null)
      .then((response) => {
        if (response.code === 404) {
          toast.error("Invalid ticket");
          return;
        }
        if (response.ticket) {
          setTicketDetails(response.ticket);
          if (response?.ticket?.engineNo) {
            getPhysicalStatus(response.ticket.engineNo);
          }
        }
      })
      .catch((err) => console.error(err));
  };
  const onRowClick = (data) => {
    loadTickectData(data?.ticketId);
    setDetail({
      isOpen: true,
      data: {
        ...data,
        replacementEngineDeliveryChallanDate:
          data.replacementEngineDeliveryChallanDate
            ? moment(data.replacementEngineDeliveryChallanDate).format(
                "DD/MM/YYYY"
              )
            : "",
        docketDate: data.docketDate
          ? moment(data.docketDate).format("DD/MM/YYYY")
          : "",
        focReceiptDate: data.focReceiptDate
          ? moment(data.focReceiptDate).format("DD/MM/YYYY")
          : "",
      },
    });
  };

  useEffect(() => {
    if (ticketDetails) {
      setDetail((prevVal) => ({
        ...prevVal,
        data: {
          ...detail.data,
          invoiceNumber: ticketDetails?.invoiceNumber || "",
          invoiceDate: ticketDetails?.invoiceDate
            ? moment(ticketDetails.invoiceDate).format("DD-MM-YYYY")
            : "",
          listNumber: ticketDetails?.listNumber || "",
          plant: ticketDetails?.plant || "",
          enginePhysicalStatus: ticketDetails?.enginePhysicalStatus || "",
          engineReplacementMode:
            convertToCamelCaseFromUnderScore(
              ticketDetails?.engineReplacementMode
            ) || "",
          oem: ticketDetails?.oem || "",
        },
      }));
    }
  }, [ticketDetails]);
  useEffect(() => {
    loadData(filters);
  }, []);

  return (
    <div className="page-body page-load">
      {detail.isOpen ? (
        <FloatEngineDetails detail={detail} setDetail={setDetail} />
      ) : (
        <div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <p className="tab-name">Float Engines</p>
              <p className="section-name">Float Engine movement</p>
            </div>
          </Box>
          <div className="si-hide-mobile">
            <CustomTable
              header={HeaderConfig}
              data={data.results || []}
              pageCount={data.totalPages}
              onClick={onRowClick}
              filters={filters}
              onChange={(page) => {
                setFilters({
                  ...filters,
                  page,
                });
                loadData({
                  ...filters,
                  page,
                });
              }}
              //   filterCom={<TicketFilters loadData={loadData} />}
              isLoading={isLoading}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FloatEngines;
